const ENDPOINTS = {
  SIGNUP: "/auth/email-request",
  LOGIN: "/auth/check/userExists",
  LOGOUT: "/auth/app/logout",
  ACCESS_CODE: "/auth/web/login/accessCode",
  GET_MESSAGE: "/chat/get-messages",
  SEND_MESSAGE: "/chat/send-message",
  CONVERSATION_LIST: "/chat/conversation-list",
  SEND_MEDIA: "/chat/send-message-media",
  MUTE_CONVERSATION: "/chat/muteConversation",
  PIN_CONVERSATION: "/chat/pinConversation",
  BLOCK_CONVERSATION: "/settings/incoming",
  BLOCK_NUMBER: "/settings/blockednumbers",
  DELETE_CONVERSATION: "/chat/delete-conversation",
  DELETE_MESSAGE: "/chat/delete-message",
  ARCHIVE_CONVERSATION: "/chat/archiveConversation",
  GET_PURCHASED_NUMBERS: "/phoneNumbers/user-purchased-numbers",
  GET_NUMBERS_LIST: "/auth/getNumbersList",
  GET_STATES: "auth/states",
  GET_CITIES: "auth/cities",
  GET_PHONE_DETAILS: "/phoneNumbers/eFone-number-details",
  BUY_PHONE_NUMBER: "/phoneNumbers/buy-efone-number",
  GET_TICKETS: "/tickets",
  INCOMING_CALLS: "/settings/incoming-calls",
  MY_NUMBERS: "/settings/my-number",
  CALLER_ID_NUMBERS: "/settings/callerId/numbers",
  CALLER_ID_NAMES: "/settings/callerId/names",
  MINUTE_USAGE: "/settings/minute-sms-usage",
  GET_VERSION: "/settings/app-latest-version",
  SMS_SETTINGS: "/settings/sms-settings",
  PROFILE_SETTINGS: "/settings/profile",
  DELETE_ACCOUNT: "/auth/check/deleteUserUsingAnEmail",
  CONFIRM_DELETE: "auth/app/user/delete",
  EMERGENCY_911: "settings/profile/e911",
  GET_CARD: "charge/cards",
  ADD_CARD: "charge/addCard",
  BILLING_DETAILS: "addons/user/billing-details",
  SUBSCRIBED_ADDON_DETAILS: "addons/user/assigned/addons",
  GET_CANCELLED_NUMBERS: "phoneNumbers/cancelled-numbers",
  ADD_CREDITS: "charge/addCredits",
  ADDONS: "addons",
  LOCATION_SEARCH: "settings/e911/locationSearch",
  LOCATION_DETAIL: "settings/e911/locationDetailE911",
  CANCEL_CALL: "addons/assign/addons",
  CANCEL_SMS: "addons/assign/sms/addons",
  CANCEL_PHONE: "phoneNumbers/cancel-efone-number",
  RESUB_PHONE: "phoneNumbers/resubscribe-phone/",
  CONTACTS_LIST: "contacts/list",
  CREATE_GROUP: "chat/group/create",
  CREATE_BROADCAST: "chat/broadcast/create",
  UPDATE_BROADCAST: "chat/broadcast/update",
  DELETE_BROADCAST: "chat/group/delete",
  GROUP_PERMISSION_UPDATE: "chat/group/update",
  MEMBER_UPDATE: "chat/group/member",
  GET_PHONE_NUMBERS: "/phoneNumbers",
  UPDATE_SCHEDULED_MSG: "chat/schedule/update",
  HOME_PHONE_PRODUCTS: "homephone/products",
  HOME_PHONE_PRODUCT_DETAILS: "home-phone-products",
  HOME_PHONE_MY_ORDERS: "home-phone-products/orders/my",
  HOME_PHONE_ORDER: "home-phone-products",
  HOME_PHONE_ORDER_ACTIVATION: "home-phone-products/orders",
};

export default ENDPOINTS;
